// extracted by mini-css-extract-plugin
export default {"side-bar":"index-module__side-bar___GU6Ts","sideBar":"index-module__side-bar___GU6Ts","logo":"index-module__logo___Gh3Js","title":"index-module__title___gEQA9"};